module.exports = __webpack_public_path__ + "static/media/pic-sl2.5b035d6a.png";